




























































import { Vue, Component, Prop } from 'vue-property-decorator';
import { VbPagination } from '@/shared/pagination/pagination.component.vue';
import { VbTooltipSlot } from '@/shared/slots/tooltip-slot.component.vue';
import Pagination from '@/domain/pagination.entity';
import ErrorMonitorEntity from '@/domain/error-monitor/entity/error-monitor.entity';
import ErrorMonitorEnum from '@/domain/error-monitor/error-monitor-enum';
import ErrorMonitorTag from '@/shared/utils/error-monitor-tag';
import DateHandler from '@/shared/utils/date-format';
import Header from './header.json';

@Component({
  components: {
    VbPagination,
    VbTooltipSlot,
  },
  filters: {
    formatDate(value: string) {
      return DateHandler.fullDateAndTime(value);
    },
  },
})

export default class ErrorMonitorDatatable extends Vue {
  @Prop({ default: false }) businessUnitId!: string;

  @Prop({ type: Boolean, default: true }) loading!: boolean;

  @Prop({ required: true }) errorMonitorList!: Array<ErrorMonitorEntity>;

  header = Header;

  searching: boolean = false;

  pagination: Pagination = new Pagination({
    page: 0,
    itemsPerPage: 10,
    sortBy: [],
    defaultSort: 'customer.name|asc',
  });

  listErros: Array<any> = [];

  getColor(value: string) {
    return ErrorMonitorTag.getColor(value as ErrorMonitorEnum);
  }

  getDescription(value: string) {
    return ErrorMonitorTag.getDescription(value as ErrorMonitorEnum);
  }

  viewDetails(id: string): void {
    this.$emit('update:viewDetails', id);
  }

  updateTable(pagination: Pagination): void {
    this.$emit('update:pagination', pagination)
  }

  updateSortBy(sortBy: string[]): void {
    this.updateTable(new Pagination({ ...this.pagination, sortBy }))
  }

  updateSortDesc(sortDesc: string[]): void {
    this.updateTable(new Pagination({ ...this.pagination, sortDesc }))
  }
}
